module.exports = "<div>\n  hello im the depth component\n</div>\n"